import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);
    const goHome = () => navigate('/main');

    return (
        <div className="container mt-5"> 
            <div className="row justify-content-center"> 
                <div className="col-md-6"> 
                    <div className="card shadow-lg border-0"> 
                        <div className="card-body text-center p-5"> 
                            <h1 className="fw-bold mb-4">페이지를 찾을 수 없습니다.</h1> 
                            <p className="lead mb-4">죄송합니다. 요청하신 페이지를 찾을 수 없습니다.</p> 
                            <div className="d-grid gap-2 d-md-block"> 
                                <button className="btn btn-primary me-md-2" type="button" onClick={goBack}>
                                    이전 페이지로 돌아가기
                                </button>
                                <button className="btn btn-secondary" type="button" onClick={goHome}>
                                    홈으로 가기
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export {NotFound};